<template>
  <div class="calc-view" id="app">
    <CalcMain class="calc-view__calc" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import CalcMain from '@/components/calc/calc-main.vue'

export default defineComponent({
  name: 'CalcView',
  components: {
    CalcMain,
  },
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.calc-view {
  margin: 40px 0;
  padding: 12px 22px;
  display: flex;
  justify-content: center;

  &__calc {
    max-width: 952px;
    width: 100%;
  }
}

@media (max-width: 600px) {
  .calc-view {
    margin: 50px 0;
    padding: 10px 15px;
  }
}
</style>
